<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="`${title}导出`"
    width="680px"
    top="12vh"
    @closed="reset"
  >
    <el-form label-width="110px">
      <el-form-item label="导出方式">
        <el-radio-group v-model="mode">
          <el-radio label="QUERY">按查询条件导出</el-radio>
          <el-radio label="SELECTED" :disabled="selectionCount === 0">按勾选项导出（{{ selectionCount }}项）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="mode === 'QUERY'" label="查询范围">
        <el-radio-group v-model="queryScope">
          <el-radio label="PAGE">当前页</el-radio>
          <el-radio label="ALL">当前查询结果全部</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="导出列">
        <el-checkbox-group v-model="selectedColumns">
          <el-checkbox v-for="column in columns" :key="column.key" :label="column.key">{{ column.label }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button :disabled="exporting" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="exporting" @click="exportData">导出 xlsx</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, required: true },
    columns: { type: Array, default: () => [] },
    selectionCount: { type: Number, default: 0 },
    exportLoader: { type: Function, required: true }
  },
  data() {
    return {
      mode: 'QUERY',
      queryScope: 'PAGE',
      selectedColumns: [],
      exporting: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.selectedColumns = this.columns.map(column => column.key)
        if (this.selectionCount === 0 && this.mode === 'SELECTED') this.mode = 'QUERY'
      }
    }
  },
  methods: {
    exportData() {
      if (!this.selectedColumns.length) {
        this.$message.warning('请至少勾选一个导出列')
        return
      }
      this.exporting = true
      Promise.resolve(this.exportLoader({
        mode: this.mode,
        queryScope: this.queryScope,
        columns: this.selectedColumns
      })).then(() => {
        this.dialogVisible = false
      }).finally(() => {
        this.exporting = false
      })
    },
    reset() {
      this.mode = 'QUERY'
      this.queryScope = 'PAGE'
      this.selectedColumns = []
      this.exporting = false
    }
  }
}
</script>
